import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class ComprasProdutosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaProduto, buscaGrupoProduto, buscaMarcaProduto, buscaUsuario } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/compras/listaProdutosHistorico', {
                params: {
                    print: true,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    produto: buscaProduto.pest_item,
                    tamanho: buscaProduto.pest_tamanho,
                    cor: buscaProduto.pest_cor,
                    grupoProduto: buscaGrupoProduto.key,
                    marcaProduto: buscaMarcaProduto.key,
                    usuario: buscaUsuario.key,
                    dataIni,
                    dataFim,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data, registro) => {
        const dataMoment = moment(registro.com_dt_compra);
        if (dataMoment) {
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            return (
                <span></span>
            )
        }
    }





    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Relatório de Produtos Comprados
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde: </span>
                                <span>{this.renderValor(this.props.qtdeVendas)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Total: </span>
                                <span>R$ {this.renderValor(this.props.totalVendas)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.mi_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="com_dt_compra"
                                dataIndex="com_dt_compra"
                                title="Emissão"
                                render={this.renderData}
                                width={160}
                                align="center"
                                className="listaCadastro"
                            />
                            {/* <Column
                                key="com_numero"
                                dataIndex="com_numero"
                                title="Num"
                                width={80}
                                align="center"
                                className="listaCadastro"
                            /> */}
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                width={200}
                                align="left"
                                className="listaCadastro"
                            />
                            {/* <Column
                                key="prod_codigo"
                                dataIndex="prod_codigo"
                                title="Prod"
                                width={80}
                                align="left"
                                className="listaCadastro"
                            /> */}
                            <Column
                                key="prod_descricao"
                                dataIndex="prod_descricao"
                                title="Descrição Produto"
                                width={200}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="mar_descricao"
                                dataIndex="mar_descricao"
                                title="Marca"
                                width={150}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="mi_qtde"
                                dataIndex="mi_qtde"
                                title="Qtde"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="mi_vlr_unit"
                                dataIndex="mi_vlr_unit"
                                title="Vlr Unit"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="mi_vlr_total"
                                dataIndex="mi_vlr_total"
                                title="Vlr Total"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default ComprasProdutosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/ComprasProdutosPrintModal.js